<div class="payout-request-kpi-list">
  @for (kpi of kpis; track kpi.title) {
  <bo-payout-request-kpi-card
    [title]="kpi.title"
    [value]="kpi.value"
    [subtitle]="kpi.subtitle"
    [valueColor]="kpi.valueColor"
  />
  }
</div>

